// React Router
import { useNavigate, useLocation } from 'react-router-dom';

// MUI
import {
    CssBaseline,
    Box,
    Divider,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Toolbar,
    IconButton,
} from '@mui/material';
import { Home, Create, Person, Settings, Logout, Sunny, DarkMode } from '@mui/icons-material';

// UUID
import { v4 as uuidv4 } from "uuid";

export default function DrawerComp(props) {
    const drawerWidth = 240;
    const navigate = useNavigate();

    let location = useLocation();

    const drawerLinks = [
        {
            title: "Home",
            icon: <Home />,
            id: uuidv4(),
            path: "/home",
        },
        {
            title: "Create",
            icon: <Create />,
            id: uuidv4(),
            path: "/create",
        },
        {
            title: "Profile",
            icon: <Person />,
            id: uuidv4(),
            path: "/profile",
        },
        {
            title: "Edit",
            icon: <Settings />,
            id: uuidv4(),
            path: "/edit",
        },
        {
            title: "Logout",
            icon: <Logout />,
            id: uuidv4(),
            path: "/",
        },

    ];

    const drawerLinksUI = drawerLinks.map((ele) => {
        return (
            <ListItem key={ele.id} disablePadding sx={{ backgroundColor: location.pathname === ele.path ? "#a0a0a0" : null }}>
                <ListItemButton onClick={() => {
                    navigate(ele.path);
                }}>
                    <ListItemIcon>
                        {ele.icon}
                    </ListItemIcon>
                    <ListItemText primary={ele.title} />
                </ListItemButton>
            </ListItem>
        )
    })

    const drawer = (
        <div>
            <Toolbar sx={{ margin: "7px 0", justifyContent: "center" }}>
                <IconButton onClick={() => {
                    props.setMyMode(props.myMode === "light" ? "dark" : "light");
                    localStorage.setItem("theme", props.myMode === "light" ? "dark" : "light");
                }}>
                    {props.myMode === "light" ? <Sunny /> : <DarkMode />}
                </IconButton>
            </Toolbar>
            <Divider />
            <List>
                {drawerLinksUI}
            </List>
        </div>
    );

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                <Drawer
                    variant="temporary"
                    open={props.mobileOpen}
                    onTransitionEnd={props.handleDrawerTransitionEnd}
                    onClose={props.handleDrawerClose}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    slotProps={{
                        root: {
                            keepMounted: true,
                        },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
        </Box>
    );
}
